/**
 * Shared layout wrapper for post create flows (intro copy + children).
 */
import React from "react";

export interface PostFormShellProps {
  intro: string;
  children: React.ReactNode;
  className?: string;
}

const PostFormShell: React.FC<PostFormShellProps> = ({ intro, children, className = "" }) => (
  <div
    className={`flex flex-col w-full sm:h-auto overflow-y-scroll sm:overflow-y-auto overflow-x-hidden space-y-4 ${className}`.trim()}
  >
    <p className="text-sm text-eoe-text-sub dark:text-eoe-dark-text-sub">{intro}</p>
    {children}
  </div>
);

export default PostFormShell;
